module.exports = __webpack_public_path__ + "img/Frente-36-01 on.1d28ca8a.png";